import { useFeatureFlag } from '@src/hooks/useFeatureFlag';
import type { FundingRateBlotterPanelConfig } from '@src/types/LayoutConfig';
import { useCallback, useEffect } from 'react';
import { Panel } from '../../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../../types';
import { FundingRateBlotterModule } from './FundingRateBlotterModule';

const DEFAULT_TITLE = 'Funding Rate Blotter (USD Aggregated)';

export function FundingRateBlotterPanel({ api, params }: LayoutPanelProps<FundingRateBlotterPanelConfig>) {
  const { enableSignals } = useFeatureFlag();

  const handleParamsChange = useCallback(
    (partial: Partial<FundingRateBlotterPanelConfig>) => api.updateParameters(partial),
    [api]
  );

  // Mirror the default title onto the dockview tab unless the user has renamed it via the tab
  // context menu (which sets customTitle on DefaultTabComponent).
  useEffect(() => {
    if (params.customTitle) {
      return;
    }
    if (api.title !== DEFAULT_TITLE) {
      api.setTitle(DEFAULT_TITLE);
    }
  }, [api, params.customTitle]);

  if (!enableSignals) {
    return null;
  }

  return (
    <Panel
      panelApi={api}
      position="relative"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      data-testid="funding-rate-blotter-panel"
    >
      <FundingRateBlotterModule params={params} onParamsChange={handleParamsChange} />
    </Panel>
  );
}
